import React from 'react';
 
function About () {
    return <div>
        <h2>Staffans GIT repositorys</h2>
 
        Homepage :
        <a href="https://www.fomalhaut.se/">
        https://www.fomalhaut.se/
        </a>
    </div>
}
export default About;
